import { render, staticRenderFns } from "./RiskScenariosTable.vue?vue&type=template&id=effdc1d8&"
import script from "./RiskScenariosTable.vue?vue&type=script&lang=js&"
export * from "./RiskScenariosTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports